"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizArtefact = void 0;
const QuizQuestion_1 = require("../QuizQuestion");
class QuizArtefact {
    constructor(data) {
        this.link = null;
        this.answerButtonLabel = "En savoir plus";
        this.validateButtonLabel = "Valider";
        this.allowMultipleAnswers = true;
        this.questions = [];
        this.hasAnswered = false;
        if (data) {
            data = (typeof data === "string") ? JSON.parse(data) : data;
            this.link = data.link;
            this.answerButtonLabel = data.answerButtonLabel || "En savoir plus";
            this.validateButtonLabel = data.validateButtonLabel || "Valider";
            this.allowMultipleAnswers = data.allowMultipleAnswers;
            this.questions = (typeof data.questions === 'undefined') ? [] : data.questions.map(q => new QuizQuestion_1.QuizQuestion(q));
            this.hasAnswered = (typeof data.hasAnswered === 'undefined') ? false : data.hasAnswered;
        }
    }
}
exports.QuizArtefact = QuizArtefact;
//# sourceMappingURL=QuizArtefact.js.map